// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13H07","right":"styles_right__3P6u9"};